/**
 * L'unico posto che sa com'è fatto un URL della sezione statistiche.
 *
 * Serve perché ogni riferimento a una entità deve essere navigabile: se lo slug si costruisse
 * dentro le pagine, l'indice e la scheda finirebbero prima o poi per calcolarlo in due modi
 * diversi e il link porterebbe a un 404.
 *
 * Lo stesso algoritmo vive in backend/scoutballitalia/models/CarrieraSlug.cs, ma solo per i
 * giocatori: se cambia qui, cambia anche là. Lo slug di una squadra qui non si calcola affatto,
 * perché la sua identità è la squadra storica — un id in database, non un nome che due iscrizioni
 * possono condividere.
 *
 * Il server lo manda già fatto sui DTO cross-torneo (indici, ricerca, carriera) e sulle squadre
 * di una edizione (`ResStatSquadra.SlugStorica`). Chi nomina una squadra senza portare anche il
 * suo slug — una partita, una riga di classifica — porta invece l'id della squadra in
 * quell'edizione, e lo slug si risolve passando per l'array delle squadre dell'edizione: vedi
 * `pages/statistiche/edizione/squadre.js`.
 */

export const BASE = '/tornei/statistiche';

const normalizza = (valore) =>
  (valore ?? '').trim().replace(/\s+/g, ' ').toLowerCase();

const senzaDiacritici = (valore) =>
  valore.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

const slug = (valore) =>
  senzaDiacritici(normalizza(valore))
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-{2,}/g, '-')
    .replace(/^-|-$/g, '');

/**
 * La forma con cui si confronta un nome di squadra mentre si filtra un elenco in pagina.
 *
 * Non è più una identità: due iscrizioni sono la stessa squadra se condividono la squadra
 * storica, che è un id, e quello lo decide il server. Questa serve solo a far sì che digitare
 * "aquile" trovi "Le Aquile" nell'indice, senza mandare una richiesta.
 */
export const chiaveSquadra = (nome) => normalizza(nome);

export const slugGiocatore = (id, nome, cognome) => {
  const coda = slug(`${nome ?? ''} ${cognome ?? ''}`);
  return coda ? `${id}-${coda}` : String(id);
};

export const idDaSlug = (valore) => {
  const m = /^(\d+)(?:-|$)/.exec(valore ?? '');
  return m ? Number(m[1]) : null;
};

export const urlGiocatore = (id, nome, cognome) => `${BASE}/giocatore/${slugGiocatore(id, nome, cognome)}`;
export const urlSquadra = (slug) => `${BASE}/squadra/${slug}`;
export const urlEdizione = (idEdizione) => `${BASE}/edizione/${idEdizione}`;
export const urlEdizioneVista = (idEdizione, vista) => `${BASE}/edizione/${idEdizione}/${vista}`;
export const urlPartita = (idEdizione, idPartita) => `${BASE}/edizione/${idEdizione}/partita/${idPartita}`;
